/* Aguamarina Cart Legal — checkbox de aceptación de políticas antes de checkout
 * Inyecta un bloque de aceptación legal en la página del carrito.
 * Deshabilita el botón de checkout hasta que el cliente acepte.
 */
(function() {
  'use strict';

  const ACCEPT_KEY = 'ag-legal-accepted';
  const BLOCK_ID = 'ag-cart-legal-block';

  function isCartPage() {
    return window.location.pathname === '/cart' ||
           window.location.pathname === '/cart/' ||
           !!document.querySelector('cart-items, #main-cart-items, .cart__items, #cart');
  }

  function buildLegalBlock() {
    const html = `
      <div id="${BLOCK_ID}" class="ag-cart-legal">
        <label class="ag-cart-legal__row">
          <input type="checkbox" id="ag-cart-legal-check">
          <span class="ag-cart-legal__check-visual">
            <svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 7l3 3 5-6"/>
            </svg>
          </span>
          <span class="ag-cart-legal__text">
            He leído y acepto las
            <a href="/pages/terminos-y-condiciones" target="_blank" rel="noopener">Términos y condiciones</a>,
            la <a href="/pages/politicas-privacidad" target="_blank" rel="noopener">Política de privacidad</a>,
            la <a href="/pages/politica-de-envios" target="_blank" rel="noopener">Política de envíos</a>
            y la <a href="/pages/cambios-devoluciones-garantias" target="_blank" rel="noopener">Política de cambios</a>.
          </span>
        </label>
        <div class="ag-cart-legal__warning" hidden>
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
            <circle cx="8" cy="8" r="6"/>
            <path d="M8 5v4M8 11v.5"/>
          </svg>
          Marca la casilla para continuar al pago.
        </div>
      </div>
    `;
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    return wrap.firstElementChild;
  }

  function findCheckoutButton() {
    // Selectores comunes en Shopify (Rise/Dawn/Horizon)
    return document.querySelector(
      'button[name="checkout"], ' +
      'button[name="add"]#checkout, ' +
      '.cart__checkout-button, ' +
      '.cart__ctas button[type="submit"], ' +
      'form[action$="/cart"] button[type="submit"], ' +
      '#checkout, ' +
      '.shopify-payment-button__button'
    );
  }

  function setCheckoutEnabled(enabled) {
    const btns = document.querySelectorAll(
      'button[name="checkout"], ' +
      '.cart__checkout-button, ' +
      '.cart__ctas button[type="submit"], ' +
      '#checkout, ' +
      '.shopify-payment-button__button'
    );
    btns.forEach(b => {
      b.disabled = !enabled;
      b.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if (enabled) {
        b.removeAttribute('data-ag-locked');
      } else {
        b.setAttribute('data-ag-locked', 'true');
      }
    });
  }

  function init() {
    if (!isCartPage()) return;
    if (document.getElementById(BLOCK_ID)) return; // ya inyectado

    const btn = findCheckoutButton();
    if (!btn) {
      // intentar de nuevo en 500ms (la página puede estar montando)
      setTimeout(init, 500);
      return;
    }

    // Inyectar bloque antes del botón
    const block = buildLegalBlock();

    // Buscar el contenedor del botón
    const btnParent = btn.closest('.cart__ctas, .cart-page__footer, .cart__footer, form');
    if (btnParent) {
      btnParent.insertBefore(block, btn.parentElement && btnParent.contains(btn.parentElement) && btn.parentElement !== btnParent ? btn.parentElement : btn);
    } else {
      btn.parentElement.insertBefore(block, btn);
    }

    // Estado inicial
    setCheckoutEnabled(false);

    const check = block.querySelector('#ag-cart-legal-check');
    const warn = block.querySelector('.ag-cart-legal__warning');

    check.addEventListener('change', () => {
      const accepted = check.checked;
      setCheckoutEnabled(accepted);
      warn.hidden = accepted;
      block.classList.toggle('is-accepted', accepted);
    });

    // Si el usuario intenta clickear el botón sin aceptar
    document.addEventListener('click', (e) => {
      const target = e.target.closest('button[name="checkout"], .cart__checkout-button, .cart__ctas button[type="submit"], #checkout, .shopify-payment-button__button');
      if (target && target.hasAttribute('data-ag-locked')) {
        e.preventDefault();
        e.stopPropagation();
        warn.hidden = false;
        block.classList.add('ag-cart-legal--shake');
        setTimeout(() => block.classList.remove('ag-cart-legal--shake'), 600);
        check.focus();
      }
    }, true);
  }

  // Init en multiple lifecycle moments para cubrir SPA-style updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inject si el cart se actualiza dinámicamente (Shopify Section Rendering API)
  document.addEventListener('cart:update', init);
  document.addEventListener('cart:refresh', init);

  // MutationObserver fallback — detecta cuando el carrito cambia
  const obs = new MutationObserver(() => {
    if (isCartPage() && !document.getElementById(BLOCK_ID)) init();
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
